import { Button, Stack, Text, Title } from "@mantine/core";
import { IconDatabaseOff } from "@tabler/icons-react";
import type { ComponentType } from "react";

interface EmptyStateProps {
  icon?: ComponentType<{ size?: number; stroke?: number }>;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({
  icon: Icon = IconDatabaseOff,
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <Stack align="center" justify="center" py="xl" gap="md">
      <Icon size={48} stroke={1.5} aria-hidden="true" />
      <Title order={4} ta="center">
        {title}
      </Title>
      {description && (
        <Text c="dimmed" ta="center" maw={400}>
          {description}
        </Text>
      )}
      {actionLabel && onAction && (
        <Button variant="light" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Stack>
  );
}
